<template>
  <div id="hres7fe-detail-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES7FEC2']['40'] }}
      </h3>
    </div>
    <div id="tab1" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="col-md-5">
          <form class="form-horizontal">
            <div class="form-group margin-b-10">
              <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['190'] }}</label>
                <div class="col-md-6">
                  <input type="radio" name="flgappr" value="P" v-model="detailTab1.detail.flgappr" > <span class="radio-text">{{ labels['HRES7FEC2']['200'] }}</span>
                  <input type="radio" name="flgappr" value="C" v-model="detailTab1.detail.flgappr" > <span class="radio-text">{{ labels['HRES7FEC2']['210'] }}</span>
                </div>
            </div>
          </form> 
          <form class="form-horizontal">
            <div class="form-group margin-b-10">
              <div class="col-lg-1" ></div>
              <label class="col-md-11 ">{{ labels['HRES7FEC2']['60'] }}</label>
              <div class="col-md-10" v-for="(item, index) in detailTab1.detail.trainingby">
                <div class="col-lg-2" ></div>
                <div class="col-md-8">
                  <input type="checkbox" name="trainingby" v-model="item.check"> <span class="checkbox-text">{{ item.name }}</span>               
              </div>
              </div>
            </div>
          </form>

          <form class="form-horizontal">
            <div class="form-group margin-b-10">
              <div class="col-lg-1" ></div>
              <label class="col-md-11">{{ labels['HRES7FEC2']['70'] }}</label>
              <div class="col-md-10" v-for="(item, index) in detailTab1.detail.informtby">
                <div class="col-lg-2" ></div>
                <div class="col-md-8">
                  <input type="checkbox" name="informtby" v-model="item.check"> <span class="checkbox-text">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-9 control-label">{{ labels['HRES7FEC2']['80'] }}</label>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['90'] }}</label>
              <div class="col-md-5">
                <hrms-num-input class="input-text width-70" 
                                v-model="detailTab1.detail.qtyprescr"
                                :numLength='9'
                                :decimal='0' 
                                name="qtyprescr"
                                data-vv-name="qtyprescr"
                                :has-error="errors.has('qtyprescr')"  />
                <!-- <input type="text" v-model="detailTab1.detail.qtyprescr"></input> -->
              </div>
            </div>       
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['100'] }}</label>
              <div class="col-md-5">
                <hrms-num-input class="input-text width-70" 
                                v-model="detailTab1.detail.qtypostscr"
                                :numLength='9'
                                :decimal='0'
                                name="qtypostscr"
                                data-vv-name="qtypostscr"
                                :has-error="errors.has('qtypostscr')"  />
                <!-- <input type="text" v-model="detailTab1.detail.qtypostscr"></input> -->
              </div>
            </div>
          </form>
          <div class="box-footer">
            <button type="button" class="btn bg-color-skin" @click="postHres7feTab1Save(saveParams())"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>  
          </div>
        </div>

        <div class="col-md-7">
          <div class="col-md-12 clear-padding">
            <div class="evaluation-wrapper">
              <template v-for="dataGroup in detailTab1.table1.rows">
                <group  :labels="labels"
                        :dataGroup="dataGroup"
                        :choices="detailTab1.table2.rows"
                        name="tab1"/>
              </template>
            </div>
          </div>
          <div class="col-md-12 clear-padding">
            <div class="evaluation-sum">
              {{ labels['HRES7FEC2']['180'] }} {{ calResultScore(detailTab1.table1.rows) }}/{{ calTotalScore(detailTab1.table1.rows) }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import group from 'components/hres7fe/group'

export default {
  name: 'hres7fe-detail-tab1',
  data () {
    return {
      checked: []
    }
  },
  props: [ 'labels', 'detailTab1', 'labelsButton', 'detail', 'postHres7feTab1Save', 'searchIndex', 'indexSelected', 'receivedHres7feDetail' ],
  methods: {
    saveParams () {
      return {
        searchIndex: this.searchIndex,
        detailTab1: this.detailTab1,
        indexSelected: this.indexSelected
      }
    },
    calResultScore (dataGroups) {
      if (dataGroups.length > 0) {
        return dataGroups.map((dataGroup) => {
          return parseFloat(dataGroup.qtyscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
      }
    },
    calTotalScore (dataGroups) {
      if (dataGroups.length > 0) {
        return dataGroups.map((dataGroup) => {
          return parseFloat(dataGroup.qtyfscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
      }
    }
  },
  components: {
    group
  }

}
</script>



// WEBPACK FOOTER //
// detailTab1.vue?b3705c26